export default "__VITE_ASSET__DLZqmMwb__"